const consentHandler = () => {
  // window.console.log = function () {};
};
export default consentHandler;
